import { engagementReportBuilder2Reports } from "@dashboardApi/apis/engagementReportBuilder2Reports";

import type { AllRouteEndpoints } from "../routeTypes";
export const engagementReportBuilder2AppGroupIdUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  engagementReportBuilder2Reports,
];
